<form nz-form se-container="1" [formGroup]="form" nzLayout="horizontal" labelWidth="150" *ngIf="!useCrossBorderPayment">
  <se-title>FROM</se-title>
  <nz-divider class="m-sm"></nz-divider>
  <se label="Account Number" required [error]="'Account Number is required.'">
    <nz-input-group [nzAddOnAfter]="accountCurrency" class="width-100">
      <nz-select formControlName="account" class="width-100" [nzCustomTemplate]="displayTpl" nzShowSearch="true"
        autocomplete="off">
        <ng-template #displayTpl let-selected>
          {{ selected.nzLabel }}
        </ng-template>
        <ng-container *ngFor="let o of bankAccs">
          <nz-option [nzValue]="o.bankAccountNo" [nzLabel]="o.bankAccountNo" nzCustomContent>
            <div>
              <strong>{{ o.bankAccountNo }}</strong>
              <nz-tag class="ml-sm">
                {{ o.currencyCode }}
              </nz-tag>
            </div>
            <div class="text-grey-dark">
              <span>{{ o.code }}</span>:
              <span> {{ o.name }}</span>
            </div>
          </nz-option>
        </ng-container>
      </nz-select>
      <ng-template #accountCurrency>
        <span class="min-width-xs">
          {{form.controls.accountCurrency.value}}
        </span>
      </ng-template>
    </nz-input-group>
  </se>

  <se-title>TO</se-title>
  <nz-divider class="m-sm"></nz-divider>
  <se label="Payee Name" required="required" error="Payee Name is required.">
    <input nz-input formControlName="payeeName" maxlength="35" />
  </se>
  <se label="Payee Address" required="required" error="Payee Address is required.">
    <input nz-input formControlName="payeeAddress1" maxlength="35" required="true" />
    <input nz-input formControlName="payeeAddress2" maxlength="35" />
    <input nz-input formControlName="payeeAddress3" maxlength="35" />
  </se>
  <se label="Bank Country" required="required" error="Bank Country is required.">
    <nz-select formControlName="payeeBankCountry" [nzOptions]="countryOptions" nzShowSearch="true" autocomplete="off">
    </nz-select>
  </se>
  <se label="Swift BIC Code" required="required" error="Swift BIC Code is required.">
    <input nz-input formControlName="payeeBankBIC" maxlength="11" />
  </se>
  <se label="Bank Name" required="required" error="Bank Name is required.">
    <input nz-input formControlName="payeeBankName" maxlength="35" />
  </se>
  <se label="Bank Address" required="required" error="Bank Address is required.">
    <input nz-input formControlName="payeeBankAddress" maxlength="35" required="true" />
  </se>
  <se label="IBAN / Account No." required="required" error="IBAN / Account Number is required.">
    <input nz-input class="width-100" formControlName="payeeAccount" maxlength="19" required="true" app-digit-only />
    <!-- <nz-input-group [nzAddOnAfter]="payeeCurrencySelect" class="width-100">
      <ng-template #payeeCurrencySelect>
        <nz-select formControlName="payeeCurrency" class="width-xs" [nzOptions]="currencyOptions" nzShowSearch="true"
          autocomplete="off" [nzDisabled]="true">
        </nz-select>
      </ng-template>
      <input nz-input formControlName="payeeAccount" maxlength="19" required="true" app-digit-only />
    </nz-input-group> -->
  </se>
  <se label="Resident Status" required>
    <nz-radio-group formControlName="isResident">
      <label nz-radio [nzValue]="true">Resident</label>
      <label nz-radio [nzValue]="false">Non-Resident</label>
    </nz-radio-group>
  </se>
  <se label="Account Type" required="required" error="Account Type is required.">
    <nz-select formControlName="isOwnAcc">
      <nz-option [nzValue]="true" nzLabel="Own Account"></nz-option>
      <nz-option [nzValue]="false" nzLabel="Third Party Account"></nz-option>
    </nz-select>
  </se>

  <se-title>AMOUNT & WHEN</se-title>
  <nz-divider class="m-sm"></nz-divider>
  <se label="Transaction Date" required [error]="'Transaction Date is required.'">
    <nz-date-picker formControlName="transferDate" [nzDisabledDate]="disabledDate"></nz-date-picker>
  </se>
  <se label="Amount" required="required" error="Transaction Amount is required."
    [optional]="'(' + form.controls.currency.value + ')'">
    <app-currency-input formControlName="amount"></app-currency-input>
  </se>
  <se label="Payment Details" required [error]="'Payment Details is required.'">
    <textarea rows="2" nz-input formControlName="paymentDetails" maxlength="140"></textarea>
  </se>
  <se label="Reference No." required [error]="'Reference No. is required.'">
    <input nz-input formControlName="payeeRef" maxlength="35" />
  </se>
</form>
